import React, { Component } from 'react';
import { currency } from './../../../helpers/';

class Item extends Component {


    render() {
        const {item, purchased, onAddToCartClicked, closeModal} = this.props;
        return (
            <div className="product-box">
                <h3 className="h3 product-title">{ item.name }</h3>
                <div className="price-default">
                    <span className="price">{ currency.convert( item.price.value ) } </span>
                    <span className="vat">{ `+ ${ currency.taxType() }` }</span>
                </div>
                <div className="basket-pop-button-hold">
                    <button type="button" className="theme-button secondary mr-1" data-dismiss="modal">
                        <span className="label">Back</span>
                    </button>
                    {
                        !purchased ?
                        <button type="button" className="btn btn-primary" onClick={ onAddToCartClicked }>
                            <span className="label">Add To Basket</span>
                            <span className="icon"><i className="fa fa-shopping-cart"/></span>
                        </button>

                        :
                        <button className="theme-button" onClick={ () => closeModal() }>
                            Go to basket
                        </button>
                    }
                </div>
                { purchased  && <p>Product has been added to the basket</p> }


            </div>
        );
    };
}

export default Item;


// WEBPACK FOOTER //
// src/client/components/common/transactions/Item.js